import { combineReducers } from "@reduxjs/toolkit";
import AuthReducer from "../Reducers/Authreducers";
import DashboarReducer from "../Reducers/Dashboardreducers";

export const rootreducer = combineReducers({
  Auth: AuthReducer,
  Dashboard: DashboarReducer,
});
